import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const knownCities = ['chisinau', 'balti', 'ungheni'];

const saleTypeMap = {
  vanzare: 1,
  chirie: 2,
};

export default function RedirectHandler() {
  const { category, city, type } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const citySlug = city?.toLowerCase();
    const saleType = saleTypeMap[type?.toLowerCase()];

    if (category && knownCities.includes(citySlug) && saleType) {
      const target = saleType === 2 ? `/${category}/${citySlug}/chirie` : `/${category}/${citySlug}`;
      navigate(target, { replace: true });
    } else {
      navigate('/404', { replace: true });
    }
  }, [category, city, type, navigate]);

  return null; // sau un loader/spinner dacă vrei
}
